export let kpiData = null;

export function setKpiDataGlobally(data) {
  kpiData = data;
}
export function getKpiData() {
    return kpiData;
}